import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BaggageLFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M17.3571 4.65H15.2143V2.55C15.2143 1.9725 14.7321 1.5 14.1429 1.5H9.85714C9.26786 1.5 8.78571 1.9725 8.78571 2.55V4.65H6.64286C5.46429 4.65 4.5 5.595 4.5 6.75V19.35C4.5 20.505 5.46429 21.45 6.64286 21.45C6.64286 22.0275 7.125 22.5 7.71429 22.5C8.30357 22.5 8.78571 22.0275 8.78571 21.45H15.2143C15.2143 22.0275 15.6964 22.5 16.2857 22.5C16.875 22.5 17.3571 22.0275 17.3571 21.45C18.5357 21.45 19.5 20.505 19.5 19.35V6.75C19.5 5.595 18.5357 4.65 17.3571 4.65ZM8.51786 18.3C8.07857 18.3 7.71429 17.943 7.71429 17.5125V9.6375C7.71429 9.207 8.07857 8.85 8.51786 8.85C8.95714 8.85 9.32143 9.207 9.32143 9.6375V17.5125C9.32143 17.943 8.95714 18.3 8.51786 18.3ZM12 18.3C11.5607 18.3 11.1964 17.943 11.1964 17.5125V9.6375C11.1964 9.207 11.5607 8.85 12 8.85C12.4393 8.85 12.8036 9.207 12.8036 9.6375V17.5125C12.8036 17.943 12.4393 18.3 12 18.3ZM13.6071 4.65H10.3929V3.075H13.6071V4.65ZM15.4821 18.3C15.0429 18.3 14.6786 17.943 14.6786 17.5125V9.6375C14.6786 9.207 15.0429 8.85 15.4821 8.85C15.9214 8.85 16.2857 9.207 16.2857 9.6375V17.5125C16.2857 17.943 15.9214 18.3 15.4821 18.3Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BaggageLFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BaggageLFilledIcon;
